import React, { useContext, useEffect, useState } from 'react';
import Button from '@digital-hig/button';
import Cross from '@digital-hig/icon/lib/build/icons/utility/cross';
import Typography from '@digital-hig/typography';
import PropTypes from 'prop-types';
// eslint-disable-next-line import/no-extraneous-dependencies
import { SvgIcon, Box } from '@mui/material';
import Filter from '@digital-hig/icon/lib/build/icons/actions/filter';
import Chip from '@digital-hig/chip';
import { useTranslation } from 'react-i18next';
import FilterBadgesRootElement from './style';
import { SRPContext } from '../../../../common/context/srpContext';
import { SRPStateInterface } from '../../../../common/context/srpInterface';
import { isFilterSelected, formatLabel } from '../../../../utils/filter.util';

const FilterBadges = (props) => {
  const {
    srpStateRef = { current: SRPStateInterface },
    appliedFilter,
    setAppliedFilter,
    dispatch,
    fetchPartnersData,
    resetFilter,
  } = useContext(SRPContext);
  const { t } = useTranslation();
  const { isToggle, handleToggle } = props;
  const {
    locations: appliedLocations = [],
    languages: appliedLanguages = [],
    solutions: appliedSolutions = [],
    services: appliedServices = [],
    specializations: appliedSpecializations = [],
    affiliations: appliedaffiliations = [],
    offerings: appliedofferings = [],
  } = appliedFilter || {};

  const [badges, setBadges] = useState([]);

  const onchangeInput = async (option, name) => {
    dispatch({ type: 'GET_SRP_LISTING', payload: [] });
    const applyData = srpStateRef?.current?.appliedFilter || appliedFilter;
    const search = { ...applyData, pageNumber: 1, [name]: option };
    await setAppliedFilter(search);
    await fetchPartnersData({ search });
  };

  const removeBadge = (badge) => {
    if (badge) {
      // Remove single badge
      const remaingBadges = appliedFilter[badge.type].filter(
        (item) => item.value !== badge.value,
      );
      onchangeInput(remaingBadges, badge.type);
      const updatedBadges = badges.filter(
        (item) => item.value !== badge.value,
      );
      setBadges(updatedBadges);
    } else {
      // Clear all
      resetFilter();
    }
  };

  useEffect(() => {
    const allFilters = [
      ...appliedLocations.map((item) => ({ ...item, type: 'locations' })),
      ...appliedLanguages.map((item) => ({ ...item, type: 'languages' })),
      ...appliedSolutions.map((item) => ({ ...item, type: 'solutions' })),
      ...appliedServices.map((item) => ({ ...item, type: 'services' })),
      ...appliedSpecializations.map((item) => ({ ...item, type: 'specializations' })),
      ...appliedaffiliations.map((item) => ({ ...item, type: 'affiliations' })),
      ...appliedofferings.map((item) => ({ ...item, type: 'offerings' })),
    ];
    setBadges(allFilters);
  }, [appliedFilter]);

  return (
    <FilterBadgesRootElement>
      <Box className="filter-badges">
        <Button
          className="showFilter"
          variant="outlined"
          startIcon={(
            <SvgIcon fontSize="medium">
              <Filter />
            </SvgIcon>
          )}
          onClick={handleToggle}
          data-wat-val={isToggle ? 'Hide filters' : 'Show filters'}
          data-wat-loc="filters"
        >
          {isToggle ? t('Hide filters') : t('Show filters') }
          {badges.length > 0 && (
            <>
              {' '}
              (
              {badges.length}
              )
            </>
          )}
        </Button>
        {isFilterSelected(appliedFilter) && (
          <Button
            className="clear-all"
            variant="text"
            onClick={() => removeBadge()}
            data-wat-val="clear all"
            data-wat-loc="filters"
          >
            <Typography variant="button-label">{t('Clear all')}</Typography>
          </Button>
        )}
        <Box className="filter-badge-row">
          {badges?.map((badge) => (
            <Chip
              key={badge.value}
              label={t(formatLabel(badge.value))}
              onDelete={() => removeBadge(badge)}
              deleteIcon={(
                <SvgIcon fontSize="medium" data-testid="close-chip">
                  <Cross />
                </SvgIcon>
              )}
            />
          ))}
        </Box>
      </Box>
    </FilterBadgesRootElement>
  );
};

FilterBadges.propTypes = {
  isToggle: PropTypes.bool.isRequired,
  handleToggle: PropTypes.func.isRequired,
};

export default FilterBadges;
